import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

/*
Usage Note: This component will not work with kendoButton
*/
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[mriIeButtonLoader]',
  templateUrl: './button-loader.component.html',
  styleUrls: ['./button-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonLoaderComponent {
  @HostBinding('style.pointer-events') get isDisabled() {
    return this.isLoading ? 'none' : 'auto';
  }

  @HostBinding('class.mri-is-loading')
  @Input('mriIeButtonLoader')
  isLoading = false;
}
